import {
  LayoutDashboard,
  BarChart3,
  Users,
  UserPlus,
  FileText,
  Settings,
  HelpCircle,
} from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <aside className="w-64 bg-green-900 text-white flex flex-col">
      <div className="px-6 py-5 text-lg font-semibold">EYES Ghana</div>

      <nav className="flex-1 px-4 space-y-1">
        <SidebarItem
          icon={<LayoutDashboard size={18} />}
          label="Dashboard"
          active={isActive("/dashboard")}
          onClick={() => navigate("/dashboard")}
        />

        <SidebarItem
          icon={<BarChart3 size={18} />}
          label="Analytics"
          active={isActive("/analytics")}
          onClick={() => navigate("/analytics")}
        />

        <SidebarItem
          icon={<Users size={18} />}
          label="Responses"
          active={isActive("/responses")}
          onClick={() => navigate("/responses")}
        />

        <SidebarItem
          icon={<FileText size={18} />}
          label="Reports"
          active={isActive("/reports")}
          onClick={() => navigate("/reports")}
        />
      </nav>

      <div className="px-4 py-4 space-y-1 border-t border-green-800">
        <SidebarItem
          icon={<UserPlus size={18} />}
          label="Register Admin"
          active={isActive("/register-admin")}
          onClick={() => navigate("/register-admin")}
        />
        <SidebarItem
          icon={<Settings size={18} />}
          label="Settings"
          active={isActive("/settings")}
          onClick={() => navigate("/settings")}
        />
        <SidebarItem
          icon={<HelpCircle size={18} />}
          label="Help Center"
          active={isActive("/help")}
          onClick={() => navigate("/help")}
        />
      </div>
    </aside>
  );
};

const SidebarItem = ({ icon, label, active, onClick }) => {
  let itemClass = `w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition`;
  
  if (active) {
    itemClass += " bg-green-700 text-yellow-400";
  } else {
    itemClass += " text-gray-200 hover:bg-green-800";
  }

  return (
    <button
      onClick={onClick}
      className={itemClass}
    >
      {icon}
      {label}
    </button>
  );
};

export default Sidebar;
